import { Alert, Dialog, Stack } from '@all-manager/design-system-v2';
import DocumentsFormSection from '../DocumentsFormSection/DocumentsFormSection';
import useAddDocumentsModal from './useAddDocumentsModal';

type Props = {
  subTopicId: string;
  onClose: () => void;
  title?: string;
};

export default function AddDocumentsModal(props: Props) {
  const {
    documents,
    setDocuments,
    handleConfirm,
    serverError,
    isConfirmationPending,
  } = useAddDocumentsModal(props);

  return (
    <Dialog
      open
      onClose={props.onClose}
      maxWidth="md"
      fullWidth
      title={props.title ?? "Réception de documents"}
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: 'Ajouter les documents',
          onClick: handleConfirm,
          loading: isConfirmationPending,
          disabled: documents.length === 0,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: props.onClose,
          disabled: isConfirmationPending,
        },
      }}
    >
      <Stack spacing={2}>
        {serverError ? <Alert severity="error">{serverError}</Alert> : null}

        <DocumentsFormSection
          documents={documents}
          onChange={setDocuments}
          subjectId={props.subTopicId}
          showProvider
        />
      </Stack>
    </Dialog>
  );
}
